module.exports = __webpack_public_path__ + "static/media/400399_02.99f5d0a2.png";